export const priceToString = (price: number | string): number => {
    // if null or undefined is passed, return 0
    if (price === null || price === undefined) {
        return 0
    }
    // if string is passed, convert it to number
    if (typeof price === 'string') {
        return Number(Number(price).toFixed(2))
    }

    return Number(price.toFixed(2))
}
